import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/core/useAuth";

export function PublicRoute({ children }) {
  const { user, staffProfile, isLoading } = useAuth();

  console.log("PublicRoute:", {
    user,
    staffProfile,
    isLoading,
    isAuthenticated: !!user && !!staffProfile,
  });

  const location = useLocation();

  // Only redirect if we're definitely authenticated (not just loading)
  if (!isLoading && user && staffProfile) {
    console.log("Redirecting from login:", {
      hasUser: !!user,
      hasStaffProfile: !!staffProfile,
      currentPath: window.location.pathname,
      state: location.state,
    });

    // Use location state if available, otherwise fallback to root
    const to = location.state?.from?.pathname || "/";
    return <Navigate to={to} replace={false} />;
  }

  // Show loading state while checking auth
  if (isLoading) {
    console.log("Loading state:", {
      isLoading,
      hasUser: !!user,
      hasStaffProfile: !!staffProfile,
    });
    return (
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: "1.2em",
        }}
      >
        Loading...
      </div>
    );
  }

  return children;
}
